import { OptionsListDrawer } from '@doltech/ui/lib/figma/Mobile/OptionsList/OptionsListDrawer';
import { useCycle } from '@doltech/ui/lib/hooks/useCycle';
import { numberToABC } from '@doltech/utils/lib/text';
import { observer } from 'mobx-react-lite';
import { getSnapshot } from 'mobx-state-tree';
import * as React from 'react';

import { useTestSubmissionStore } from '../../../model/test-submissions.hook';
import { QuestionBoxMobile } from '../QuestionBoxMobile';
import { QuestionMatchingMobile } from './QuestionMatchingMobile';

interface QuestionMatchingProps {
  formattedQuestionNo: any;
  onRemoveAnswerAtIndex: any;
  onAnswerQuestion: any;
  userAnswers: any;
  options: any;
  questionList: any;
  title: string;
  numberToString?: any;
}

export const DoTestQuestionMatchingMobile = observer((props: QuestionMatchingProps) => {
  const [isOpen, toggleOpen] = useCycle(false, true);
  const [blankId, setBlankId] = React.useState(undefined);
  const {
    formattedQuestionNo,
    onAnswerQuestion,
    userAnswers,
    options,
    questionList,
    title,
    numberToString,
  } = props;
  const store = useTestSubmissionStore();
  const [questionNo, setQuestionNo] = React.useState(0);
  const answerQuestion = (item) => {
    if (store.preventUserAction()) return;
    toggleOpen();
    onAnswerQuestion([
      {
        key: blankId,
        value: item.key,
      },
    ]);
  };

  const onItemClick = (item, no) => {
    setBlankId(item);
    toggleOpen();
    setQuestionNo(no);
  };
  const onClose = () => {
    toggleOpen();
  };

  return (
    <QuestionBoxMobile>
      {questionList &&
        questionList.map((opt, index) => (
          <QuestionMatchingMobile
            userAnswers={userAnswers}
            no={formattedQuestionNo + index}
            index={index}
            onItemClick={() => {
              onItemClick(index, formattedQuestionNo + index);
            }}
            key={index}
            title={opt.value}
            options={options}
            numberToString={numberToString}
          />
        ))}

      <OptionsListDrawer
        qNumber={questionNo}
        title={title}
        selectedOpt={getSnapshot(userAnswers)}
        numberToString={numberToString || numberToABC}
        visible={isOpen}
        options={options}
        onItemClick={answerQuestion}
        onClose={onClose}
      />
    </QuestionBoxMobile>
  );
});
